import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorEligibilityRuleHasRelation } from '../editor-eligibility-rule/editor-eligibility-rule-has-relation.model';


@Component({
    selector: 'eas-editor-eligibility-rule-value-has-relation',
    templateUrl: './editor-eligibility-rule-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleValueHasRelationComponent implements OnInit, OnChanges, OnDestroy {
  @Input() rule: EditorEligibilityRuleHasRelation;
  @Input() affirmative: boolean;

  private destroyed$ = new Subject<void>();

  relationNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.relationNamesWithCategoryNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        relationNamesWithCategoryNames => {
          this.relationNamesWithCategoryNames = relationNamesWithCategoryNames;
          this.value = this.getValue();
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rule || changes.affirmative) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.relationNamesWithCategoryNames === undefined) {
      return $localize `Not available`;
    }

    const relation = this.rule.getRelationName(this.relationNamesWithCategoryNames);
    const relationValue = this.rule.getRelationCategoriesAsString(this.relationNamesWithCategoryNames);

    let value = this.affirmative
      ? $localize `Candidate has the relation ${relation}`
      : $localize `Candidate has NOT the relation ${relation}`;

    if (relationValue !== '') {
      value = $localize `${value} with value ${relationValue}`;
    }

    return value;
  }
}
